// import isEmpty from "lodash/isEmpty";
import { parseJSON } from "@/utils/common";
import { CATALOG } from "@/utils/constant";
const CACHED_CATALOG_MODULES = [CATALOG.STRIP_LIST, CATALOG.PART_CATALOG];

const defaultModuleState = (moduleName) => ({
  data: parseJSON(sessionStorage.getItem(`${moduleName}Data`), null),
  currentStep: 1,
  step1: {
    recentSearches: parseJSON(
      localStorage.getItem(`${moduleName}-recent-searches`),
      []
    ),
  },
  isToyota: null,
});

const state = () => ({
  modules: {
    stripList: defaultModuleState(CATALOG.STRIP_LIST),
    partCatalog: defaultModuleState(CATALOG.PART_CATALOG),
  },
});

const mutations = {
  SET_CACHE_DATA(state, { moduleName, payload }) {
    state.modules[moduleName].data = payload;
  },
  SET_RECENT_SEARCHES(state, { moduleName, payload }) {
    state.modules[moduleName].step1.recentSearches = payload;
  },
  SET_IS_TOYOTA(state, { moduleName, payload }) {
    state.modules[moduleName].isToyota = payload;
  },
  PREV_STEP(state, moduleName) {
    const moduleData = state.modules[moduleName]?.data;
    if (!moduleData) return;

    const currentStep = state.modules[moduleName].data.currentStep;
    if (currentStep > 1) {
      state.modules[moduleName].data.currentStep -= 1;
      if (!CACHED_CATALOG_MODULES.includes(moduleName)) {
        const stepKeys = Object.keys(moduleData)
          .filter((key) => key.startsWith("step"))
          .map((key) => Number(key.replace("step", "")))
          .sort((a, b) => a - b);

        const lastStep = stepKeys.pop();

        delete moduleData[`step${lastStep}`];

        state.modules[moduleName].data = { ...moduleData };
      }
    } else {
      state.modules[moduleName].data = null;
      state.modules[moduleName].data.currentStep = 1;
    }

    sessionStorage.setItem(
      `${moduleName}Data`,
      JSON.stringify(state.modules[moduleName].data)
    );
  },

  NEXT_STEP(state, moduleName) {
    state.modules[moduleName].data.currentStep += 1;
    sessionStorage.setItem(
      `${moduleName}Data`,
      JSON.stringify(state.modules[moduleName].data)
    );
  },
};

const actions = {
  setCacheData(
    { state, commit },
    { moduleName, step, key, data, isUpdateStep = true }
  ) {
    const currentData = state.modules[moduleName]?.data || {};
    const stepKey = `step${step}`;
    const stepData = key
      ? {
          ...(currentData[stepKey] || {}),
          [key]: data,
        }
      : data;
    const updatedData = {
      ...currentData,
      [stepKey]: stepData,
    };

    if (isUpdateStep) {
      updatedData.currentStep = step;
    }

    commit("SET_CACHE_DATA", { moduleName, payload: updatedData });
    sessionStorage.setItem(`${moduleName}Data`, JSON.stringify(updatedData));
  },

  setCacheSelectedItems({ state, dispatch }, { moduleName, step, key, data }) {
    const stepKey = `step${step}`;
    const currentStepData = state.modules[moduleName]?.data?.[stepKey] || {};
    let arrItems = [];
    if (currentStepData[key] && Array.isArray(currentStepData[key])) {
      arrItems = [...currentStepData[key]];
      arrItems.unshift(data);
    } else {
      arrItems = [data];
    }
    dispatch("setCacheData", {
      moduleName,
      step,
      key,
      data: arrItems,
      isUpdateStep: false,
    });
  },

  clearCacheData({ commit }, moduleName) {
    commit("SET_CACHE_DATA", { moduleName, payload: null });
    commit("SET_IS_TOYOTA", { moduleName, payload: null });
    sessionStorage.removeItem(`${moduleName}Data`);
  },

  setRecentSearches({ state, commit }, { moduleName, payload }) {
    let recent = [...state.modules[moduleName].step1.recentSearches];
    recent = recent.filter((item) => item !== payload);
    if (recent.length >= 10) recent.pop();
    recent.unshift(payload);

    localStorage.setItem(
      `${moduleName}-recent-searches`,
      JSON.stringify(recent)
    );
    commit("SET_RECENT_SEARCHES", { moduleName, payload: recent });
  },

  goToPreviousStep({ commit }, moduleName) {
    commit("PREV_STEP", moduleName);
  },

  goToNextStep({ commit }, moduleName) {
    commit("NEXT_STEP", moduleName);
  },

  setIsToyota({ commit }, { moduleName, payload }) {
    commit("SET_IS_TOYOTA", { moduleName, payload });
  },
};

const getters = {
  getDataFromCache: (state) => (moduleName) => {
    return state.modules[moduleName]?.data;
  },
  getRecentSearches: (state) => (moduleName) => {
    return state.modules[moduleName]?.step1?.recentSearches || [];
  },
  currentStep: (state) => (moduleName) => {
    return state.modules[moduleName]?.data?.currentStep || 1;
  },
  getIsToyota: (state) => (moduleName) => {
    return state.modules[moduleName]?.isToyota;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
